import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { TaskWorkspaceStore } from '../../../../core/h3ml/state/task-workspace-store';
import { SelectionService } from '../../../../core/outputs/annotation/annotation-shared/utils/selection.service';
import { RootKeyboardShortcutService } from '../../../../core/shared/keyboard-shortcuts/root-keyboard-shortcut.service';
import { AnnotationCreateDeleteService } from '../../../../core/shared/misc-services/annotation-create-delete.service';
import { SettingsKeyboardShortcutsService } from './settings-keyboard-shortcuts.service';

export const annotationTabName = 'annotation';
export const settingsTabName = 'settings';

@Component({
  selector: 'h3-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidePanelComponent extends DirectiveSuperclass {
  annotationTabName = annotationTabName;
  settingsTabName = settingsTabName;
  selectedTabName$ =
    inject(TaskWorkspaceStore)('sidePanel')('selectedTabName').$;

  private keyboardShortcutService = inject(RootKeyboardShortcutService);
  private selectionService = inject(SelectionService);
  private annotationCreateDeleteService = inject(AnnotationCreateDeleteService);
  private settingsKeyboardShortcutsService = inject(
    SettingsKeyboardShortcutsService,
  );

  constructor() {
    super();
    this.setSubscriptionToDeleteAllKeyboardEvents();
    this.settingsKeyboardShortcutsService.register();
  }

  private setSubscriptionToDeleteAllKeyboardEvents() {
    this.subscribeTo(
      this.keyboardShortcutService.getEvent$('deleteShapes'),
      ({ eventTrackingValue }) => {
        const selectedShapeIndexes =
          this.selectionService.getSelectedShapeIndexes();
        this.annotationCreateDeleteService.deleteShapes(
          selectedShapeIndexes,
          eventTrackingValue,
        );
      },
    );
  }
}
